//
//
//
//
//
//
//
//
//
//
//
var urlRegex = /^(?:(?:https?:)?\/\/)?(?:www\.)?(?:m\.)?(?:youtu(?:be)?\.com\/(?:v\/|embed\/|watch(?:\/|\?v=))|youtu\.be\/)((?:\w|-){11})(?:\S+)?$/;
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      videoUrl: "",
      width: null,
      height: null,
      paddingBottom: null
    };
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      this.width = this.$length(this.spec.width);
      this.height = this.$length(this.spec.height);

      if (this.height == null) {
        // Let the container calculates the height
        this.height = "100%";

        if (this.width == "100%") {
          // 16:9 aspect ratio
          // See https://stackoverflow.com/questions/35814653/automatic-height-when-embedding-a-youtube-video
          this.paddingBottom = "56.25%";
        } else {
          Utils.type.ifNumber(this.spec.width, function (val) {
            var height = val * 9 / 16;
            _this.paddingBottom = "".concat(height, "px");
          });
        }
      }

      var url = this.spec.url;

      if (this.isYoutube(url)) {
        this.videoUrl = this.embededYoutubeUrl(this.extractYoutubeId(url));
      } else {
        this.videoUrl = url;
      }
    },
    styles: function styles() {
      var styles = this.$styles(); // See https://stackoverflow.com/questions/35814653/automatic-height-when-embedding-a-youtube-video

      styles["position"] = "relative";
      styles["padding-bottom"] = this.paddingBottom;
      return styles;
    },
    isYoutube: function isYoutube(url) {
      return !!String(url).match(urlRegex);
    },
    extractYoutubeId: function extractYoutubeId(url) {
      var match = urlRegex.exec(url);
      return match ? match[1] : false;
    },
    embededYoutubeUrl: function embededYoutubeUrl(youtubeId) {
      return "https://www.youtube.com/embed/:youtubeId".replace(":youtubeId", youtubeId);
    }
  }
};